import React, { useEffect, useState } from 'react'
import Budget from '../../Component/Budget'
import Managebtn from '../../Component/Managebtn'

function Index() {
    const [time, setTime] = useState("")

    const getTime = (val) => {
        setTime(val)
    }
    useEffect(()=>{
        window.scrollTo({top:'0',behavior:'instant'})
    },[])
    return (
        <>
            {/* <div className="try_fisibilty_wrapper " style={{
                transform: 'translateY(0%)',
                margin: '0px',
                justifyContent: 'start',
                background: '#031f31ff'

            }}>
                <div className="container-fluid">
                    <p className="text-left">Budget Manager / Track budget</p> </div>
            </div> */}

            <div style={{
                background: 'linear-gradient(rgb(15, 36, 55),#fff)',
            }}>
                <div className='container-fluid pt-3 mb-3'>
                    <div className='task_head'> Setup Budget</div>
                </div>
                <div className='container-fluid' style={{
                    border: '4px solid #fff',
                    borderRadius: '25px',
                    padding: '20px 20px 0px 20px',
                    marginBottom:'40px'
                }}>
                    <Managebtn white={true} getTime={getTime} value={time} />
                    <Budget time={time} setTime={setTime} />
                </div>

            </div>

        </>
    )
}

export default Index